module.exports = __webpack_public_path__ + "img/video-solid.ffd89c20.svg";